import $ from 'jquery';

		var load_locations_by_proximity = {
			init: function() {
				$(window).on('load', this.init_load_locations_by_proximity);
			},
			init_load_locations_by_proximity: function() {
				if (typeof NOURIA_VARS.ajax_url === 'undefined') {
					return false;
				}
				var data = {
					action: 'get_locations_by_proximity',
				};

				$.ajax({
					type: 'POST',
					url: NOURIA_VARS.ajax_url,
					data: data,
					//success: function(response) {},
					success: function(response) {
						if (typeof response === 'string' && response.trim().length != 0) {
							var response = JSON.parse(response);

							if (response.locations_list != false && $('.locations-list').length) {
								$('.locations-list').html(response.locations_list);
							}
							if (response.location_card != false && $('.location-cards').length) {
								$('.location-cards').html(response.location_card);
							}

							// Reinitialize location search functionality after DOM update
							reinitializeLocationSearch();
						}
					},
					dataType: 'html'
				});

				return false;
			}
		};

		load_locations_by_proximity.init();

		// ✅ Reinitialize location search functionality after AJAX update
		function reinitializeLocationSearch() {
			// Wait for global functions to be available (max 2 seconds)
			let attempts = 0;
			const maxAttempts = 20; // 20 attempts * 100ms = 2 seconds

			function tryReinitialize() {
				attempts++;

				if (typeof window.attachEventListenersToDefaultLocations === 'function') {
					window.attachEventListenersToDefaultLocations();
					return;
				}

				if (attempts < maxAttempts) {
					setTimeout(tryReinitialize, 100);
				} else {
					// Fallback to local implementation
					attachEventListenersToDefaultLocations();
				}
			}

			tryReinitialize();
		}

		// ✅ Attach click event to default locations (fallback implementation)
		function attachEventListenersToDefaultLocations() {
			document.querySelectorAll(".locations-list-link").forEach(link => {
				link.addEventListener("click", function(e) {
					e.preventDefault();
					const locationData = {
						id: this.getAttribute("data-id").replace("location-card-", ""),
						title: this.getAttribute("data-title"),
						address: this.getAttribute("data-address"),
						phone: this.getAttribute("data-phone"),
						image: this.getAttribute("data-image"),
						url: this.getAttribute("data-url"),
					};

					// Use global function if available, otherwise use local
					if (typeof window.updateLocationCard === 'function') {
						window.updateLocationCard(locationData);
					} else {
						updateLocationCard(locationData);
					}
					if (typeof window.highlightActiveLocation === 'function') {
						window.highlightActiveLocation(locationData.id);
					} else {
						highlightActiveLocation(locationData.id);
					}
				});
			});
		}

		// ✅ Update the Single Location Card Dynamically
		function updateLocationCard(location) {
			var locationImage = document.getElementById("location-image");
			var locationImageLink = document.getElementById("location-image-link");
			var locationTitle = document.getElementById("location-title");
			var locationAddress = document.getElementById("location-address");
			var moreInfoLink = document.getElementById("more-info-link");

			if (locationImage) locationImage.src = location.image;
			if (locationImageLink) locationImageLink.href = location.url;
			if (locationTitle) {
				locationTitle.textContent = location.title;
				locationTitle.href = location.url;
			}
			if (locationAddress) locationAddress.innerHTML = `${location.address}<br>${location.phone}`;
			if (moreInfoLink) moreInfoLink.href = location.url;
		}

		// ✅ Highlight active location in `.locations-list`
		function highlightActiveLocation(locationId) {
			document.querySelectorAll(".locations-list-link").forEach(item => {
				item.classList.remove("is-active");
				if (item.getAttribute("data-id") === `location-card-${locationId}`) {
					item.classList.add("is-active");
				}
			});
		}
